import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "./routes";
import { themeChakra } from "./styles/theme-chakra";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthProvider } from "./contexts/AuthContext";

const queryClient = new QueryClient();

// @ts-ignore
// document.body.style.zoom = "80%";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={themeChakra}>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AuthProvider>
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;
